
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["loadDinData","filterDinData","callLoad","callFilter","onmessage"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "51ab92ed7dede44b47c4.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "51ab92ed7dede44b47c4.worker.js");
					addMethods(w, methods)
					
					return w
				}
			